import { ErrorWrapper, ResponseWrapper } from '../util'
import { BaseService } from './../base'

export class UserService extends BaseService {
  static get entity () {
    return 'user'
  }
  static get name () {
    return 'user'
  }

  static async changePassword (userId, data) {
    try {
      const response = await this.request().put(`${this.profile}/${this.entity}/change_passwd/${userId}`, data)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }
}